<template>
  <!-- XOL-586 (D-2026-10-16c): the line under step 2's / step 5's Send / Re-send {status}
       e-Mail button: when that e-mail last went, how it fared, and to whom (the read-only
       MailBatchDialog). It exists only while the e-mailed content is unchanged: the API puts
       `approvalMail` on the step row, and nulls it the moment the status, date, remarks or
       anything else the e-mail shows changes. XOL-67: an RTA's decision e-mail has no step row, so
       the batch can be handed in as `mail` (state.rta.tc.decisionMail, the same shape). -->
  <div v-if="lastMail" class="approval-last-sent">
    <i class="fa fa-envelope text-muted" aria-hidden="true"></i>
    <el-tag size="mini" effect="light" class="approval-last-sent__tag" :type="line.tag.type"><i v-if="line.tag.icon" class="fa" :class="line.tag.icon" aria-hidden="true"></i><span>{{line.tag.text}}</span></el-tag>
    <!-- Carlos, 2026-10-18 (option C): the sentence is plain text so it wraps after
         the tag; only the short "Details" opens the dialog. A whole-sentence button
         could not wrap and dropped onto its own line. -->
    <span class="approval-last-sent__text">{{line.text}}</span>
    <el-button type="text" size="mini" class="approval-last-sent__link"
      aria-haspopup="dialog"
      :aria-label="line.aria"
      @click="openDialog">{{line.details}}</el-button>

    <mail-batch-dialog
      :visible="dialog"
      :action-id="actionData.id"
      :batch-id="lastMail.batch_id"
      :steps="actionData.steps || []"
      :rtx="actionData.actionType || 'request'"
      :status="lastMail.status || null"
      @close="dialog = false" />
  </div>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import MailBatchDialog from '@/components/requests/MailBatchDialog'
import { approvalMailLine } from '@/lib/requestActivity'

export default {
  name: 'approval-mail-line',

  mixins: [DateMixins],

  components: {
    MailBatchDialog
  },

  props: {
    // The party-1 step row of step 2 or 5.
    step: {
      type: Object,
      default: null
    },

    // XOL-67: the last-sent batch itself ({batch_id, sent_at, status, triggered_by, counts, ...}),
    // for an e-mail that has no step row: an RTA's `state.rta.tc.decisionMail`. When it is given
    // it wins over `step.approvalMail`; without it the step callers are as they were.
    mail: {
      type: Object,
      default: null
    },

    // The request (its id, its steps, its type).
    actionData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      dialog: false
    }
  },

  computed: {
    // The batch to show: the one handed in, else the step's.
    lastMail () {
      if (this.mail) {
        return this.mail
      }

      return this.step && this.step.approvalMail ? this.step.approvalMail : null
    },

    line () {
      return approvalMailLine(this.lastMail, { formatDateTime: this.formatDateTime })
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    }
  }
}
</script>

<style scoped>
.approval-last-sent { margin-top: 6px; font-size: 12px; line-height: 1.5; }
.approval-last-sent__tag .fa { margin-right: 5px; }
.approval-last-sent__text { color: #606266; }
.approval-last-sent__link { margin-left: 4px; padding: 0; line-height: 1.5; vertical-align: baseline; }
</style>
